/** ヘッダーの高さ */
export const HEADER_HEIGHT = '64px';
/** 診断画面 大項目タブの幅 */
export const CATEGORY_TAB_WIDTH = '185px';
/** 基本情報が開いている時の高さ */
export const BASIC_INFO_AREA_UP = '384px';
/** 基本情報が閉じている時の高さ */
export const BASIC_INFO_AREA_DOWN = '0px';
/** 基本情報が開いている時のボタンのTop */
export const BASIC_INFO_BUTTON_UP = '225px';
/** 基本情報が閉じている時のボタンのTop */
export const BASIC_INFO_BUTTON_DOWN = '64px';
/** ダイアログのデフォルトstyle */
export const DIALOG_BOX_STYLE = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60vw',
  maxWidth: '550px',
  boxShadow: '10px 10px 10px rgba(20, 5, 5, 0.25)',
  bgcolor: 'background.paper',
  p: 4,
} as const;
/** 画面右下に固定する追加ボタンのサイズ(直径) */
export const ADD_BUTTON_SIZE = '75px';
/** 判定結果のラベル文字色 */
export const JUDGEMENT_LABEL_COLOR = {
  OK: 'blue',
  NG: 'red',
  NA: 'gray',
};
/** 先端部画像のサイズ */
export const DTA_IMAGE_SIZE = '275px';
/** 診断Topの大項目カードの間隔 */
export const PROGRESS_CARD_GAP = '1rem';
/** 読み込み中の背景 */
export const LOADING_BACKDROP_STYLE = {
  color: 'gray',
  bgcolor: 'transparent',
};
/** スピンボタンを非表示 */
export const HIDE_SPIN_BUTTON_STYLE = {
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
};
/** パーツ選択 コンテンツ上の余白 */
export const PARTS_SELECTION_CONTENTS_TOP = '40px';
/** パーツ選択 フッターの高さ */
export const PARTS_SELECTION_FOOTER_HEIGHT = '70px';
/** テーブルのヘッダー */
export const TABLE_HEADER = {
  backgroundColor: '#67BDA7',
  color: 'white',
  padding: '1rem',
};
/** 1行で指定幅から溢れると省略表示 */
export const TEXT_OVERFLOW_1LINE = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
/** 2行で指定幅から溢れると省略表示 */
export const TEXT_OVERFLOW_2LINES = {
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
};
/** 3行で指定幅から溢れると省略表示 */
export const TEXT_OVERFLOW_3LINES = {
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
};

/** 印刷時に非表示にする */
export const PRINT_REPORT_NOT_DISPLAY = {
  displayPrint: 'none',
};

/** 帳票ダウンロード（印刷）用スタイル */
export const PRINT_REPORT_PAGE = {
  '@media print': {
    mt: 0,
    zoom: '55%',
    scale: '0.98',
    printColorAdjust: 'exact',
    '@page:first': {
      margin: 0,
      marginBottom: '3mm',
    },
    '@page': { size: 'A4', margin: '3mm 0' },
  },
};

/** 印刷時に分割しない設定 */
export const PRINT_REPORT_BREAK_AVOID = {
  '@media print': { breakInside: 'avoid' },
};

/** 帳票の結果欄の横幅(%) */
export const REPORT_RESULT_WITH = {
  INSPECTION: 6,
  FORMAT: 4,
};

/** パーツ選択画面の文字設定 */
export const PARTS_SELECTION_FONT_SIZE = '0.75rem';

/** パーツ選択画面の文字設定 */
export const DUPLICATE_PARTS_COLOR = 'rgba(0, 0, 0, 0.2)';

/** 診断項目管理の固定位置（左）の初期値 */
export const MANAGE_ITEM_LEFT_POSITION = [0, 35, 105, 305, 340, 375];
